module.exports = "<div class=\"tags contentStreamTags\">\n  <div ng-repeat=\"tag in document.tags | orderBy:'toString()'\" class=\"configTagSummary\">\n    <span ng-class=\"{'inactiveTag': !isActiveTagName(tag)}\"><span title=\"{{tag}}\" class=\"configTagNameSummary\">{{tag | truncate:16}}</span><span ng-click=\"tagRemove(document.documentId, tag)\" class=\"icon-close click-target\"></span></span>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./source/components/content-stream-tags/content-stream-tags.html
// module id = 416
// module chunks = 0